import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { LoaderService } from '../../core/services/loader.service';

@Component({
  selector: 'app-loader',
  imports: [CommonModule],
  templateUrl: './loader.html',
  styleUrl: './loader.css',
})
export class Loader {
  isLoading$!: Observable<boolean>;
  message$!: Observable<string>;

  constructor(private loaderService: LoaderService) {
    this.isLoading$ = this.loaderService.loading$;
    this.message$ = this.loaderService.message$;
  }
}
